import { render, staticRenderFns } from "./AscStockChart.vue?vue&type=template&id=ca54c3aa&scoped=true&"
import script from "./AscStockChart.vue?vue&type=script&lang=js&"
export * from "./AscStockChart.vue?vue&type=script&lang=js&"
import style0 from "./AscStockChart.vue?vue&type=style&index=0&id=ca54c3aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca54c3aa",
  null
  
)

export default component.exports